/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { hasAllCommonItems, intersection } from "~/tools";
import { SubnetOption, Vpc } from "../types";
import { generateSelectedSubnets } from "../utils";

export function useVpcSubnets(initialSubnets: string[], vpcs: Vpc[]) {
  const [selectedSubnets, setSelectedSubnets] = useState<SubnetOption[]>(
    generateSelectedSubnets(initialSubnets, vpcs)
  );
  const selectedSubnetIds = selectedSubnets.map((subnet) => subnet.subnetId);
  const isDisabled = hasAllCommonItems(initialSubnets, selectedSubnetIds);

  const removedSubnets = intersection(initialSubnets, selectedSubnetIds);

  return {
    selectedSubnetIds,
    selectedSubnets,
    setSelectedSubnets,
    removedSubnets,
    isDisabled,
  };
}
